import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const getAllDeliverableList = (params) => AxiosClient.get('/deliverable', params);
const getAllLegalDeliverableList = (params) => AxiosClient.get('/deliverable/legal-documents', params);
const getAllNonLegalDeliverableList = (params) => AxiosClient.get('/deliverable/non-legal-documents', params);
const createDeliverable = (payload) => AxiosClient.post('/deliverable', payload);
const removeDeliverable = (deliverable, payload) => AxiosClient.put(`/deliverable/delete/${deliverable}`, { ...payload })
const updateDeliverable = (deliverable, payload) => AxiosClient.put(`/deliverable/${deliverable}`, { ...payload });
const updateDeliverableStatus = (payload) => AxiosClient.put(`/deliverable/status`, payload);
const getDeliverableDetails = (deliverable, query) => AxiosClient.get(`/deliverable/${deliverable}`, { ...query })
const getDeliverableDocumentDetails = (deliverable, query) => AxiosClient.get(`/deliverable/document/${deliverable}`, { ...query })
export {
    getAllDeliverableList,
    createDeliverable,
    updateDeliverable,
    removeDeliverable,
    updateDeliverableStatus,
    getDeliverableDetails,
    getAllLegalDeliverableList,
    getAllNonLegalDeliverableList,
    getDeliverableDocumentDetails
}